import commonStyles from '../styles.module.scss'
import useStore from 'base/store'
import { PermissionType } from 'common/types'
import {Text, Button, Modal} from 'common/components'
import {useOpen} from 'common/hooks'
import {RequestPushBack, RequestApproveForm, CheckActionsProps} from '..'

export default function DirectorCheckActions({
  // role,
  request,
  isRequestLoading,
}: CheckActionsProps) {
  const permissions: PermissionType[] = useStore((state) => state.permissions)
  const [isOpen, handleOpen, handleClose] = useOpen()

  const isNotAllowed = !permissions?.includes('edit loan request (director approval)')

  return (
    <>
      <div className={commonStyles.checkActions}>
        <Text size="xs">
          <Text as="span" weight="demiBold">
            Director
          </Text>{' '}
          can approve the offer unconditional or with approval conditions
        </Text>
        { !isNotAllowed && (
          <div>
            <Button disabled={isRequestLoading} onClick={handleOpen}>
              Approve the offer
            </Button>
            <RequestPushBack
              requestUuid={request.uuid}
              disabled={isRequestLoading}
            />
          </div>
        )}
      </div>
      <Modal
        width={486}
        title={`‘${request.project.title}’ offer approval`}
        open={isOpen}
        onCancel={handleClose}
      >
        <RequestApproveForm request={request} onClose={handleClose} />
      </Modal>
    </>
  )
}
